<div class="pie-chart" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch">
	<canvas #pieChart fxFlex="1 1" fxFlex.xs="auto"></canvas>
</div>
